import { HELP_CATEGORIES, getPopularArticles } from 'content/helpContent';
import HelpArticleLink from './HelpArticleLink';
import CategoryCard from './CategoryCard';
import SearchButton from './SearchButton';

export default function HelpCenter() {
  const popularArticles = getPopularArticles();

  return (
    <>
      <div className="tw-max-w-screen-lg tw-mx-auto tw-w-full tw-px-2.5 lg:tw-px-20 tw-pt-10">
        <h1 className="tw-font-display tw-text-xl tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 sm:tw-text-3xl tw-pb-2">
          👋 How can we help today?
        </h1>
        <SearchButton />
      </div>
      <div className="tw-relative">
        <div className="tw-max-w-screen-lg tw-mx-auto tw-w-full tw-px-2.5 lg:tw-px-20 tw-pt-10 tw-pb-20">
          <div className="tw-relative tw-mb-10 tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 tw-bg-white dark:tw-bg-gray-900 tw-px-4 tw-py-6">
            <h2 className="tw-px-4 tw-font-display tw-text-2xl tw-font-bold tw-text-gray-700 dark:tw-text-gray-200">
              Popular Articles
            </h2>
            <div className="tw-mt-4 tw-grid tw-gap-2 md:tw-grid-cols-2">
              {popularArticles.map(article => (
                <HelpArticleLink key={article.slug} article={article} />
              ))}
            </div>
          </div>
          <div className="tw-grid tw-gap-4 sm:tw-grid-cols-2 md:tw-grid-cols-3">
            {HELP_CATEGORIES.map(category => (
              <CategoryCard
                key={category.slug}
                href={`/help/category/${category.slug}`}
                name={category.title}
                description={category.description}
                icon={category.icon}
                pattern={{
                  y: 16,
                  squares: [
                    [0, 1],
                    [1, 3],
                  ],
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
